import React from 'react'
import { Link } from 'react-router-dom'

function Banner() {
  return (
<div className="ttm-page-title-row ttm-bg ttm-bgimage-yes ttm-bgcolor-darkgrey clearfix">
  <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-12">
        <div className="ttm-page-title-row-inner">
          <div className="page-title-heading">
            <h2 className="title">About Us</h2>
          </div>
          <div className="breadcrumb-wrapper">
            <span>
              <Link to='/'><a title="Homepage">Home</a></Link>
            </span>
            <span>About Us</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default Banner